import { GhccRequestSuffix } from './Ghcc';
import { ContentType } from './Session';

export type ActivityResults = {
  progress: number;
  duration: number;
};

export enum ActivityMetaType {
  answer = 'answer',
  listen = 'listen',
  read = 'read',
  watch = 'watch',
  write = 'write',
}

export type ActivityMeta = {
  name?: string;
  type?: ActivityMetaType;
  icon: string;
};

export enum ActivityType {
  assessment = 'assessment',
  conversationalLearning = 'conversational-learning',
  driveToSell = 'drive-to-sell',
  ghccActivity = 'ghcc-activity',
  simpleText = 'simple-text',
  smartInfo = 'smart-info',
  video = 'video',
}

export enum ActivityStatus {
  ready = 'ready',
  incomplete = 'incomplete',
  completed = 'completed',
  passed = 'passed',
  failed = 'failed',
  notAttempted = 'not attempted',
  notInitialized = 'not-initialized',
}

export type Activity = {
  id: number;
  courseCode: string;
  name: string;
  description: string;
  type: string;
  duration: number;
  nodeTypeId: number;
  contextId: string;
  contentId?: number;
  contentType?: ContentType;
  status?: ActivityStatus;
  progress?: number;
  studiedDuration?: number;
  activityType?: ActivityType;
  activityUrl?: string;
  fallbackToGHCC?: boolean;
  contentName?: string;
  contentCategory?: string;
  contentImageUrl?: string;
};

export type SaveGhccActivityProgressData = {
  suffix: GhccRequestSuffix;
  moduleId: string;
  ts1: number;
  ts2: number;
  ModuleStart: boolean;
  PlayerStart: boolean;
  contextId?: string;
  progressOTP?: string;
};

export type SaveNonGhccActivityProgressData = {
  courseCode: string;
  activityId: string;
  sessionTime: number;
  score: number;
  ModuleStart?: boolean;
  PlayerStart?: boolean;
  contextId?: string;
  progressOTP?: string;
};

export type ActivityProgressUpdate = {
  courseCode: string;
  completionPercent: number;
  score?: number;
};

export type GhActivityDetails = {
  courseCode: string;
  activityId: number;
  activityUrl: string;
  element: HTMLIFrameElement | Window;
};

export type ActivityUserProgress = {
  id: number;
  courseCode: string;
  progress: number;
  studiedDuration: number;
  status: ActivityStatus;
};
